import React, {useEffect, useMemo, useState, useRef} from 'react';
import {useTheme} from '@mui/material/styles';
import Swal from 'sweetalert2';
import {getLocations} from "../../store/fuse/map";

import {APIProvider, Map} from "@vis.gl/react-google-maps";
import Markers from "./Markers";

const MapaSitios = (props) => {
  const [coordinates, setCoordinates] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [addresses, setAddresses] = useState([]);
  //token API google
  const tokenMapGoogle = 'AIzaSyAp52C1gKE20gSFDERSY43SWxPSFWhlnU4';
  const position = {lat: 24.4607258, lng: -33.3645766};
  const theme = useTheme();
  //ids maps
  const MapStyles = ['f8fad26d597045bc', '41f1cacd59227f57']
  const [mapConfig, setMapConfig] = useState(MapStyles[0]);

  useEffect(() => {
    try {
      getLocations().then(response => {
        if (response) {
          setCoordinates(response);
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al procesar la solicitud',
            text: 'Hubo un error al procesar la solicitud.',
          });
        }
      });
    } catch (error) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al procesar la solicitud',
        text: error.message || 'Hubo un error al procesar la solicitud.',
      });
    }
  }, []);

 
  return (
      <APIProvider apiKey={tokenMapGoogle}>
        <Map
          defaultCenter={position}
          defaultZoom={2}
          mapId={mapConfig}
          disableDefaultUI
          fullscreenControl
          zoomControl
        >
            <Markers points={coordinates}/>
        </Map>
      </APIProvider>
  );
};

export default MapaSitios;